import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import styled from 'styled-components';

const CustomSwitch = ({
    label,
    value,
    handleSwitch
}) => {
    return (
        <FlexContainer>
            <Label className='pl-0'>{label}</Label>
            <Switch
                className="custom-switch custom-switch-primary"
                checked={value}
                onClick={handleSwitch}
            />
        </FlexContainer>
    );
}

export default CustomSwitch;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

{/* <FormGroup className='custom-form-group pb-1 px-2 text-center'>
<Label className='custom-label pl-0'>{label}</Label>
<Switch
    className="custom-switch custom-switch-primary"
    checked={value}
    onClick={handleSwitch}
/>
</FormGroup> */}